import { Screen } from '@betty/navigation';
import PaymentMethodVerificationCards from '../../../components/PaymentMethodVerification/PaymentMethodVerificationCards/PaymentMethodVerificationCards';

function PaymentMethodVerificationCardsScreen() {
  return (
    <Screen paddingHorizontal="space-0">
      <PaymentMethodVerificationCards />
    </Screen>
  );
}

export default PaymentMethodVerificationCardsScreen;
